import { createContext } from "react";

export const GeneralAuthorizationLayoutContext = createContext<{
  label?: string;
  subLabel?: string;
}>({});
